import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { composeAvatarUrl } from '@/lib/avatar';

/**
 * Author block at the top of a story view page. Shows avatar, name, and
 * (when available) a short bio.
 *
 * All fields come pre-joined from `km_public_stories` — no per-page
 * profile fetch, no UUID exposure. Anonymous stories pass null for the
 * avatar/bio so this component still renders cleanly with just the
 * "Anonymous" byline.
 */
export default function StoryAuthorCard({
  authorName,
  avatarObjectKey = null,
  bio = null,
}) {
  const avatarUrl = composeAvatarUrl(avatarObjectKey);
  const initials = (authorName || '')
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('') || '?';

  return (
    <div
      className="bg-[#FBF4EB] rounded-lg border border-[#E6E2D6] p-4 sm:p-5 flex gap-4"
      data-testid="story-author-card"
    >
      <Avatar className="h-12 w-12 flex-shrink-0 border border-[#E6E2D6]">
        {avatarUrl ? <AvatarImage src={avatarUrl} alt="" /> : null}
        <AvatarFallback className="bg-white text-[#C05621] text-sm font-medium">
          {initials}
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#2D2A26]">{authorName}</p>
        {bio ? (
          <p className="text-xs text-[#6B665E] mt-1 line-clamp-2">{bio}</p>
        ) : null}
      </div>
    </div>
  );
}
